/* unplugin-vue-components disabled */import { render } from "./HeaderForPC.vue?vue&type=template&id=5f975635&scoped=true"
import script from "./HeaderForPC.vue?vue&type=script&lang=js"
export * from "./HeaderForPC.vue?vue&type=script&lang=js"

import "./HeaderForPC.vue?vue&type=style&index=0&id=5f975635&scoped=true&lang=less"

import exportComponent from "/Users/jiaohong/Documents/code/workSpace/kuaitandain-official-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f975635"]])

export default __exports__